<div class="tree-list-actions" [ngClass]="{ 'is-hidden': hidden() }">
  <div class="tree-list-actions-transparent-bgrd" [ngClass]="{ 'is-hidden': hidden() }">
    <ng-template #renderAction let-action>
    <div class="tree-list-action-wrapper" [ngClass]="action?.wrapperClass">
      @if (!action.multiple) {
      <button
        mat-button
        class="tick-btn"
        [ngClass]="action?.class"
        [disabled]="action?.disabled"
        (click)="action?.command(data())"
        title="{{ action?.tooltipValue | translate }}"
        [appHasRight]="action?.rights"
      >
        @if (action?.icon) {
        <mat-icon>{{ action.icon }}</mat-icon>
        } {{ action?.contextLabel?.(data()) || action?.label }}
      </button>
      } @else {
      <app-btn-group className="{{ action?.class }}" [items]="action.groupItems(data())">
      </app-btn-group>
      }
    </div>
    </ng-template>

    @for (action of primaryActions(); track $index) {
    <ng-container *ngTemplateOutlet="renderAction; context: { $implicit: action }"></ng-container>
    }
    @if (overflowItems()?.length) {
    <div class="tree-list-action-wrapper">
      <app-btn-group
        className="tick-btn-default"
        [items]="overflowItems()"
        [withTogglerIcon]="true"
      ></app-btn-group>
    </div>
    }
    @if (visibleFixedActions()?.length) {
    @for (action of visibleFixedActions(); track $index) {
    <ng-container *ngTemplateOutlet="renderAction; context: { $implicit: action }"></ng-container>
    }
    }
  </div>
</div>


